import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import TextField from '../../Common/UI/TextField';


import debounce from 'lodash/debounce';

const useStyles = makeStyles((theme) => style(theme));

function ProjectFilterTextField ({ filter, onFilterChange }) {
    const classes = useStyles();

    function handleFilterChange (event) {
        onFilterChange(event.target.value);
    }
    // const debouncedHandleChange = debounce(handleFilterChange, 1000);
    // function handleChange(value){
    //     debouncedHandleChange(value);
    // }

    return (
        <TextField
            className={classes.root}
            placeholder={'Search for project'}
            fullWidth
            onChange={handleFilterChange}
            value={filter}
        />
    );

}

const style = theme => ({
    root: {
        maxWidth: 300,
        marginLeft: 'auto'
    }
});

export default ProjectFilterTextField;